export const SolutionsHeader = () => {
    return (
        <p className="description-medium">
            We offer solutions that can{' '}
            <span>
                <br />
            </span>
            respond <span className="color-text">to future climate change</span>
            <span>
                <br />
            </span>{' '}
            and related challenges.
        </p>
    );
};

export const AboutUsHeader = () => {
    return (
        <h1>Our history</h1>
    )
}
